import { $body, $window, $document } from '../utils/environment';
import AbstractModule from './AbstractModule';

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.init();
    }

    init() {
        this.$el.find('table').wrap('<div class="c-wysiwyg-table"></div>');
    }

    wrapTable() {
    }

    destroy() {
    }
}
